<!-- pricing.component.html -->
<div class="pc-page">

  <!-- ─── HERO ─── -->
  <section class="pc-hero">
    <div class="pc-hero-inner">
      <p class="pc-hero-eyebrow">11+ Regular Course, 2026/27 Academic Year</p>
      <h1 class="pc-hero-title">Choose Your Child's <span>Path to Success </span> <br>
         <span class="pc-price-amount"> As low as £7.99<span class="pc-price-unit">/session</span></span></h1>

      <!-- <div class="pc-hero-badges">
        <span class="pc-badge"><i class="ti ti-calendar-event"></i> Starts 1 Sep 2026</span>
        <span class="pc-badge"><i class="ti ti-device-laptop"></i> 100% Online</span>
        <span class="pc-badge"><i class="ti ti-credit-card"></i> Instalment Options</span>
      </div> -->

      <!-- ─── STYLED FEATURE CHIPS ─── -->
      <div class="pc-hero-points">

        <!-- Expert-Led Live Lessons -->
        <div class="pc-hero-point">
          <span class="pc-hp-icon-wrap">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/>
            </svg>
          </span>
          <span class="pc-hp-text">Expert-Led Live Lessons</span>
        </div>

        <!-- Personalised Progress Tracking -->
        <div class="pc-hero-point">
          <span class="pc-hp-icon-wrap">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
            </svg>
          </span>
          <span class="pc-hp-text">Personalised Progress Tracking</span>
        </div>

        <!-- Exam-Style Homework -->
        <div class="pc-hero-point">
          <span class="pc-hp-icon-wrap">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
            </svg>
          </span>
          <span class="pc-hp-text">Exam-Style Homework &amp; Assessments</span>
        </div>

        <!-- Regular Parent Updates -->
        <div class="pc-hero-point">
          <span class="pc-hp-icon-wrap">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </span>
          <span class="pc-hp-text">Regular Parent Updates &amp; PTMs</span>
        </div>

        <!-- Grammar School Readiness -->
        <div class="pc-hero-point">
          <span class="pc-hp-icon-wrap pc-hp-icon-gold">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </span>
          <span class="pc-hp-text">Grammar School &amp; Exam Readiness</span>
        </div>

      </div>
    </div>
  </section>


  <!-- ─── PRICING SECTION ─── -->
  <section class="pc-section">
    <div class="pc-section-inner">

      <div class="pc-intro">
        <h2 class="pc-intro-title">Find the Right Plan for <span>Your Child</span></h2>
        <p class="pc-intro-sub">All plans run Sep 2026 – Jul 2027 &nbsp;·&nbsp; Flexible live class timings Mon–Sat &nbsp;·&nbsp; Online delivery</p>
      </div>

      <!-- ─── CARDS ─── -->
      <div class="pc-cards">

        <!-- YEAR 5 — FEATURED -->
        <div class="pc-card pc-card-featured">
          <div class="pc-card-header">
            <p class="pc-card-year">Best for Year 5 Entry</p>
            <h3 class="pc-card-title">Year 5 Plan</h3>
            <p class="pc-card-sub">Full 11+ experience with F2F mocks</p>
            <div class="pc-card-price">
              <span class="pc-cp-label">As Low as</span>
              <span class="pc-cp-amount">£7.99<span>/session</span></span>
            </div>
          </div>
          <div class="pc-card-body">
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-calendar"></i> Duration</span><span class="pc-sv pc-sv-gold">46 Weeks</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-video"></i> Live classes</span><span class="pc-sv pc-sv-cyan">231 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-clock"></i> Per week</span><span class="pc-sv">5 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-test-pipe"></i> Practice tests</span><span class="pc-sv">140 online</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-pencil"></i> Assignments</span><span class="pc-sv">140 sets</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-users"></i> PTM sessions</span><span class="pc-sv">8 meetings</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-stat-row"><span class="pc-sl">Maths</span><span class="pc-sv pc-sv-gold">62 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">English (RC + CW)</span><span class="pc-sv pc-sv-gold">62 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Verbal Reasoning</span><span class="pc-sv pc-sv-gold">31 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Non-Verbal Reasoning</span><span class="pc-sv pc-sv-gold">30 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Doubt Clearing</span><span class="pc-sv">46 sessions</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feat pc-feat-highlight"><i class="ti ti-school"></i> 30 Face-to-Face Mock Exams</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Comprehensive RAR dashboard</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Pre-class notes &amp; materials</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Recorded session access</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Error log &amp; result history</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Weak area analysis &amp; counselling</div>
            <div class="pc-feat"><i class="ti ti-check"></i> LMS technology platform</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Customised subject options</div>
            <a routerLink="/enrol" class="pc-cta pc-cta-primary">Sign Up &rarr;</a>
          </div>
        </div>

        <!-- YEAR 4 -->
        <div class="pc-card">
          <div class="pc-card-header">
            <p class="pc-card-year">Best for Year 4 Entry</p>
            <h3 class="pc-card-title">Year 4 Plan</h3>
            <p class="pc-card-sub">Build strong foundations early</p>
            <div class="pc-card-price">
              <span class="pc-cp-label">As Low as</span>
              <span class="pc-cp-amount">£7.99<span>/session</span></span>
            </div>
          </div>
          <div class="pc-card-body">
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-calendar"></i> Duration</span><span class="pc-sv pc-sv-org">46 Weeks</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-video"></i> Live classes</span><span class="pc-sv pc-sv-teal">184 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-clock"></i> Per week</span><span class="pc-sv">4 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-test-pipe"></i> Practice tests</span><span class="pc-sv">129 online</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-pencil"></i> Assignments</span><span class="pc-sv">129 sets</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-users"></i> PTM sessions</span><span class="pc-sv">8 meetings</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-stat-row"><span class="pc-sl">Maths</span><span class="pc-sv pc-sv-teal">46 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">English (RC + CW)</span><span class="pc-sv pc-sv-teal">46 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Verbal Reasoning</span><span class="pc-sv pc-sv-teal">23 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Non-Verbal Reasoning</span><span class="pc-sv pc-sv-teal">23 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Doubt Clearing</span><span class="pc-sv">46 sessions</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feat pc-feat-missing"><i class="ti ti-x"></i> No F2F Mock Exams</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Comprehensive RAR dashboard</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Pre-class notes &amp; materials</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Recorded session access</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Error log &amp; result history</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Weak area analysis &amp; counselling</div>
            <div class="pc-feat"><i class="ti ti-check"></i> LMS technology platform</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Customised subject options</div>
            <a routerLink="/enrol" class="pc-cta pc-cta-outline">Sign Up &rarr;</a>
          </div>
        </div>

        <!-- YEAR 3 -->
        <div class="pc-card">
          <div class="pc-card-header">
            <p class="pc-card-year">Best for Year 3 Entry</p>
            <h3 class="pc-card-title">Year 3 Plan</h3>
            <p class="pc-card-sub">Get ahead with an early start</p>
            <div class="pc-card-price">
              <span class="pc-cp-label">As Low as</span>
              <span class="pc-cp-amount">£7.99<span>/session</span></span>
            </div>
          </div>
          <div class="pc-card-body">
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-calendar"></i> Duration</span><span class="pc-sv pc-sv-org">46 Weeks</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-video"></i> Live classes</span><span class="pc-sv pc-sv-teal">184 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-clock"></i> Per week</span><span class="pc-sv">3 sessions</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-test-pipe"></i> Practice tests</span><span class="pc-sv">137 online</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-pencil"></i> Assignments</span><span class="pc-sv">137 sets</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-users"></i> PTM sessions</span><span class="pc-sv">8 meetings</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Subject breakdown</p>
            <div class="pc-stat-row"><span class="pc-sl">Maths</span><span class="pc-sv pc-sv-teal">46 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">English (RC + CW)</span><span class="pc-sv pc-sv-teal">46 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Verbal Reasoning</span><span class="pc-sv pc-sv-teal">23 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Non-Verbal Reasoning</span><span class="pc-sv pc-sv-teal">23 classes</span></div>
            <div class="pc-stat-row"><span class="pc-sl">Doubt Clearing</span><span class="pc-sv">46 sessions</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feat pc-feat-missing"><i class="ti ti-x"></i> No F2F Mock Exams</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Comprehensive RAR dashboard</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Pre-class notes &amp; materials</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Recorded session access</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Error log &amp; result history</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Weak area analysis &amp; counselling</div>
            <div class="pc-feat"><i class="ti ti-check"></i> LMS technology platform</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Customised subject options</div>
            <a routerLink="/enrol" class="pc-cta pc-cta-outline">Sign Up &rarr;</a>
          </div>
        </div>

        <!-- SINGLE SUBJECT -->
        <div class="pc-card">
          <div class="pc-card-header">
            <p class="pc-card-year">Flexible Option</p>
            <h3 class="pc-card-title">Single Subject</h3>
            <p class="pc-card-sub">Targeted prep in one area</p>
            <div class="pc-card-price">
              <span class="pc-cp-label">As Low as</span>
              <span class="pc-cp-amount">£49<span>/m</span></span>
            </div>
          </div>
          <div class="pc-card-body">
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-calendar"></i> Duration</span><span class="pc-sv pc-sv-org">46 Weeks</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-video"></i> Live classes</span><span class="pc-sv pc-sv-teal">Tailored</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-clock"></i> Per week</span><span class="pc-sv">Flexible</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-test-pipe"></i> Practice tests</span><span class="pc-sv">Per subject</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-pencil"></i> Assignments</span><span class="pc-sv">Per subject</span></div>
            <div class="pc-stat-row"><span class="pc-sl"><i class="ti ti-users"></i> PTM sessions</span><span class="pc-sv">8 meetings</span></div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Choose your subject</p>
            <div class="pc-feat"><i class="ti ti-check"></i> Maths</div>
            <div class="pc-feat"><i class="ti ti-check"></i> English — RC &amp; Creative Writing</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Verbal Reasoning</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Non-Verbal Reasoning</div>
            <div class="pc-divider"></div>
            <p class="pc-sec-label">Key highlights</p>
            <div class="pc-feat"><i class="ti ti-check"></i> Customised schedule &amp; pace</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Comprehensive RAR dashboard</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Recorded session access</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Error log &amp; result history</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Weak area analysis</div>
            <div class="pc-feat"><i class="ti ti-check"></i> LMS technology platform</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Flexible instalment payment</div>
            <div class="pc-feat"><i class="ti ti-check"></i> Cancellation policy included</div>
            <a routerLink="/contact" class="pc-cta pc-cta-outline">Sign Up &rarr;</a>
          </div>
        </div>

      </div><!-- /pc-cards -->

      <!-- ─── SHARED FEATURES ─── -->
      <div class="pc-shared">
        <p class="pc-shared-title">What Your Child Gets</p>
        <div class="pc-shared-grid">
          <div class="pc-shared-item" *ngFor="let item of sharedFeatures">
            <i class="ti" [class]="'ti ' + item.icon"></i>
            <div>
              <p class="pc-si-title">{{ item.title }}</p>
              <p class="pc-si-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</div><!-- /pc-page -->